import React from 'react'; 
import { connect } from 'react-redux';
import {fetchBillProjectionData} from '../../../../dataFetchers/billProjectionDataFetcher';
import BillProjection from './BillProjection';

class BillProjectionContainer extends React.Component{

    componentDidMount(){
        if(!this.props.billProjectionData){
            this.props.fetchBillProjectionData(this.props.userId, this.props.configs.data["date_format"]);
        }
    }

    render(){
        return(
            <>
                {this.props.billProjectionData !== null && <BillProjection translations={this.props.translations} billProjectionData={this.props.billProjectionData.data} billProjectionError={this.props.billProjectionData.failed} configs={this.props.configs} />}
            </>
        )
    }
}

const mapStateToProps = state => {
    return{
        userId : state.userIdentityDetails.userId,
        billProjectionData : state.billProjectionData,
        translations : state.translationsData.data,
        configs: state.configs
    }
}

const mapDispatchToProps = dispatch => {
    return{
        fetchBillProjectionData : (uuid, dateFormat) => dispatch(fetchBillProjectionData(uuid, dateFormat))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BillProjectionContainer);
